import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persistedstate'
import localforage from 'localforage'

Vue.use(Vuex)
// 自动引入modules目录下的模块
function getModules() {
  const modulesFiles = require.context('./modules', false, /\.js$/)
  const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
  }, {})
  return modules
}

// 使用web的localStorage来保存该数据
const windowPersist = new VuexPersistence({
  asyncStorage: true,
  storage: localforage.createInstance({
    name: 'PHWebStore',
    driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB]
  }),
  modules: ['fund', 'common']
})

export default new Vuex.Store({
  modules: getModules(),
  plugins: [windowPersist]
})



// WEBPACK FOOTER //
// ./src/store/index.js